var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('FilePicker',{attrs:{"config":_vm.config},model:{value:(_vm.value.url),callback:function ($$v) {_vm.$set(_vm.value, "url", $$v)},expression:"value.url"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }